// overview

export const STORAGE_OVERVIEW_LIST = 'STORAGE_OVERVIEW_LIST'
export const STORAGE_CLEAN_INPUT_LIST = 'STORAGE_CLEAN_INPUT_LIST'
export const STORAGE_CLEAN_INPUT_LIST_PAGE_SIZE = 'STORAGE_CLEAN_INPUT_LIST_PAGE_SIZE'
export const STORAGE_CLEAN_INPUT_LIST_PAGE_COUNT = 'STORAGE_CLEAN_INPUT_LIST_PAGE_COUNT'
export const STORAGE_CLEAN_INPUT_LIST_TOTAL = 'STORAGE_CLEAN_INPUT_LIST_TOTAL'
export const STORAGE_CLEAN_INPUT_BID = 'STORAGE_CLEAN_INPUT_BID'
export const STORAGE_CLEAN_INPUT_USER_ID = 'STORAGE_CLEAN_INPUT_USER_ID'
// export const STORAGE_CLEAN_INPUT_LAST_LOGIN_DAY = 'STORAGE_CLEAN_INPUT_LAST_LOGIN_DAY'
// export const STORAGE_CLEAN_INPUT_LAST_COMPLETE_DAY = 'STORAGE_CLEAN_INPUT_LAST_COMPLETE_DAY'
// export const STORAGE_CLEAN_INPUT_LAST_PAY_DAY = 'STORAGE_CLEAN_INPUT_LAST_PAY_DAY'
// export const STORAGE_CLEAN_INPUT_MIN_SPACE = 'STORAGE_CLEAN_INPUT_MIN_SPACE'
// export const STORAGE_CLEAN_INPUT_MIN_LAST_SUBMIT_DAY = 'STORAGE_CLEAN_INPUT_MIN_LAST_SUBMIT_DAY'

// whiteList
export const SET_WHITE_LIST = 'SET_WHITE_LIST'
export const SET_WHITE_LIST_SEARCH_PARAMS = 'SET_WHITE_LIST_SEARCH_PARAMS'

// storageMamagement
export const SET_STORAGE_MANAGEMENT = 'SET_STORAGE_MANAGEMENT'
export const SET_LINK_MOUNT_LIST = 'SET_LINK_MOUNT_LIST'
export const SET_LINK_MOUNT_QUERY = 'SET_LINK_MOUNT_QUERY'
export const SET_LINK_MOUNT_PAGE_NUM = 'SET_LINK_MOUNT_PAGE_NUM'
export const SET_LINK_MOUNT_PAGE_SIZE = 'SET_LINK_MOUNT_PAGE_SIZE'

// setTranferTask
export const SET_TRANSFER_TASK = 'SET_TRANSFER_TASK'

// set leisu version
export const SET_LEISU_VERSION = 'SET_LEISU_VERSION'

// autoClean
export const SET_LOADING_AUTO_CLEAN = 'SET_LOADING_AUTO_CLEAN'
export const SET_AUTO_CLEAN_PARAMS = 'SET_AUTO_CLEAN_PARAMS'
export const SET_AUTO_CLEAN_LIST = 'SET_AUTO_CLEAN_LIST'
export const SET_AUTO_CLEAN_LIST_PAGE_NUM = 'SET_AUTO_CLEAN_LIST_PAGE_NUM'
export const SET_AUTO_CLEAN_LIST_PAGE_SIZE = 'SET_AUTO_CLEAN_LIST_PAGE_SIZE'
export const SET_AUTO_CLEAN_LIST_TOTAL = 'SET_AUTO_CLEAN_LIST_TOTAL'
export const SET_LOADING_TIME_RULE = 'SET_LOADING_TIME_RULE'
export const SET_TIME_RULE_LIST = 'SET_TIME_RULE_LIST'

// userTaskValidityPeriodManagement
export const SET_USER_TASK_VALIDITY_PERIOD_LIST = 'SET_USER_TASK_VALIDITY_PERIOD_LIST'
export const SET_LOADING_USER_TASK_VALIDITY_PERIOD = 'SET_LOADING_USER_TASK_VALIDITY_PERIOD'
export const SET_USER_TASK_VALIDITY_PERIOD_PAGE_NUM = 'SET_USER_TASK_VALIDITY_PERIOD_PAGE_NUM'
export const SET_USER_TASK_VALIDITY_PERIOD_PAGE_SIZE = 'SET_USER_TASK_VALIDITY_PERIOD_PAGE_SIZE'
export const SET_USER_TASK_VALIDITY_PERIOD_TOTAL = 'SET_USER_TASK_VALIDITY_PERIOD_TOTAL'
export const SET_USER_TASK_VALIDITY_PERIOD_QUERY = 'SET_USER_TASK_VALIDITY_PERIOD_QUERY'
